module.exports = __webpack_public_path__ + "static/img/lucre-games-app-store-icon.9bc2018.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lucre-games-app-store-icon.png
// module id = knKY
// module chunks = 0